import {
    deleteCareRecipientMemo,
    getCareRecipientMemoList, registerCareRecipientMemo, updateCareRecipientMemo
} from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientMemoContent } from "../../../../domain/care_recipient_memo/CarerecipientMemoContent";
import { CareRecipientMemo } from "../../../../domain/care_recipient_memo/CarerecipientMemo";
import { CareRecipientMemoId } from "../../../../domain/care_recipient_memo/CareRecipientMemoId";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/CareRecipientMemo",
    getList: "getList",
    register: "register",
    update: "update",
    delete: "delete",
});

export const getCareRecipientMemoListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async(data: { careRecipientId: CareRecipientId }, { rejectWithValue }) => {
        const response = await getCareRecipientMemoList(data.careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const registerCareRecipientMemoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.register}`,
    async(data: { careRecipientId: CareRecipientId, memoContent: CareRecipientMemoContent }, { rejectWithValue }) => {
        const response = await registerCareRecipientMemo(data.careRecipientId, data.memoContent);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response.careRecipientMemo };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const updateCareRecipientMemoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async(data: { careRecipientMemo: CareRecipientMemo }, { rejectWithValue }) => {
        const response = await updateCareRecipientMemo(data.careRecipientMemo);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response.careRecipientMemo };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const deleteCareRecipientMemoAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.delete}`,
    async(data: { careRecipientMemoId: CareRecipientMemoId }) => {
        deleteCareRecipientMemo(data.careRecipientMemoId);
        return data.careRecipientMemoId.value;
    }
);